import React, { useState, useEffect } from 'react';
//import {
//  Paper,
//  Container,
//  TextField,
//  MenuItem,
//  FormControl,
//  InputLabel,
//  Select,
//} from '@material-ui/core';
//import { Button, GridContainer, GridItem } from '@intervan-ar/ov-componentes';
//import { makeStyles } from '@material-ui/core/styles';
//import { makeAPICall } from '../../core/services/http-request';
//import { NavLink } from 'react-router-dom';
//import { getFullUrl } from '../../core/globals';

const Dashboard = props => {
  return <div></div>;
};

export default Dashboard;
